var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$utils.isPermited(_vm.permission))?_c('div',[_c('b-overlay',{attrs:{"show":_vm.busy,"spinner-variant":"primary","spinner-type":"grow","variant":_vm.skin}},[_vm._t("default")],2)],1):_c('span',[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }